/**
 * Primary Timeframe Indicators Helpers
 *
 * - Ensure stable IDs
 * - Strip IDs for DB
 * - Normalize for engine
 * - Update by ID (not by index)
 */

import type { PTI, PTI_DB, PTI_Engine } from '@/types/indicators';

/**
 * Ensure all indicators have stable IDs (generate if missing)
 */
export function ensureIndicatorIds(arr: any[]): PTI[] {
  return arr.map(i => ({
    ...i,
    id: i.id ?? crypto.randomUUID()
  })) as PTI[];
}

/**
 * Update indicator by ID (immutable)
 */
export function updateIndicatorById(arr: PTI[], next: PTI): PTI[] {
  return arr.map(i => (i.id === next.id ? next : i));
}

/**
 * Remove indicator by ID (immutable)
 */
export function removeIndicatorById(arr: PTI[], id: string): PTI[] {
  return arr.filter(i => i.id !== id);
}

/**
 * Strip UI-only 'id' field for DB storage
 */
export function stripIdsForDB(arr: PTI[]): PTI_DB[] {
  return arr.map(({ id, ...rest }) => rest as PTI_DB);
}

/**
 * Normalize indicators for engine (same as DB for now)
 */
export function normalizeIndicatorsForEngine(arr: PTI[]): PTI_Engine[] {
  return stripIdsForDB(arr);
}

/**
 * Deep clone indicator for draft editing
 */
export function deepCloneIndicator<T>(obj: T): T {
  return JSON.parse(JSON.stringify(obj));
}

/**
 * Clamp number value
 */
export function clamp(value: number, min: number, max: number): number {
  return Math.max(min, Math.min(max, value));
}
